export default "__VITE_ASSET__aZ1p4U45__"